import { useAuth0 } from '@auth0/auth0-react';
import { ExpandLess, ExpandMore, Logout, Person } from '@mui/icons-material';
import { Avatar, Box, Divider, ListItemIcon, Menu, MenuItem, Skeleton, Typography } from '@mui/material';
import { stringAvatar } from '@src/app/utils/StringUtils';
import { logoutCallbackUrl, profileUrl } from '@src/app/utils/UrlBuilder';
import { useState } from 'react';
import { useHistory } from 'react-router';

export const UserProfile = (): JSX.Element => {
  const { user, isLoading, logout } = useAuth0();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const history = useHistory();
  const open = Boolean(anchorEl);

  if (isLoading) {
    return <Skeleton variant="rounded" width="100px" />;
  }

  const name = user?.name ?? '';
  const email = user?.email ?? '';

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Box
        sx={{
          display: { xs: 'flex', md: 'none' },
          p: 2,
          justifyContent: 'center',
          alignItems: 'center',
          cursor: 'pointer',
        }}
        onClick={handleClick}
      >
        <Avatar {...stringAvatar(name)} />
      </Box>

      <Box
        sx={{ ':hover': { cursor: 'pointer' }, backgroundColor: '#FAFAFA', borderRadius: '100px', display: { xs: 'none', md: 'flex' } }}
        onClick={handleClick}
        p={2}
        gap="8px"
        borderRadius="100px"
        alignItems="center"
      >
        <Avatar {...stringAvatar(name)} />
        <Box display="flex" flexDirection="column">
          <Typography color="#222">{name}</Typography>
          <Typography color="#646">{email}</Typography>
        </Box>
        {open ? <ExpandLess sx={{ color: '#222222' }} /> : <ExpandMore sx={{ color: '#222222' }} />}
      </Box>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <Box px={2} py={1}>
          <Typography variant="subtitle1">{name}</Typography>
          <Typography variant="body2" color="text.secondary">
            {email}
          </Typography>
        </Box>

        <Divider />

        <Box padding="6px 8px 6px 8px" mt={1} display="flex" flexDirection="column" gap={1}>
          <MenuItem
            onClick={() => {
              history.push(profileUrl());
              handleClose();
            }}
            sx={{ borderRadius: '8px' }}
          >
            <ListItemIcon>
              <Person fontSize="small" />
            </ListItemIcon>
            Profile
          </MenuItem>

          <MenuItem
            onClick={() => {
              handleClose();
              logout({ returnTo: logoutCallbackUrl() });
            }}
            sx={{ borderRadius: '8px' }}
          >
            <ListItemIcon>
              <Logout fontSize="small" />
            </ListItemIcon>
            Sign out
          </MenuItem>
        </Box>
      </Menu>
    </>
  );
};
